import { mat4, quat, vec2, vec3 } from 'gl-matrix'
import Object3D from '../core/Object3D'

export default class Camera extends Object3D {
  constructor() {
    super();
    this.up = [0, 1, 0];
    this.projectionMatrix = mat4.create();
    this.viewMatrix = mat4.create();
    this.lookAt(0, 0, 0);
  }

  lookAt(x, y, z) {
    mat4.lookAt(this.viewMatrix, this.position, [x, y, z], this.up);
    const invMat = mat4.create();
    mat4.invert(invMat, this.viewMatrix);
    mat4.getRotation(this.quaternion, invMat);
  }
}
